import styled from 'styled-components/macro';
import Link from 'components/atoms/Link';

export const TemplateHolder = styled.div`
  position: relative;
  z-index: 1;

  @media (min-width: 992px) {
    min-height: 100vh;
    height: 100%;
    display: flex;
  }
`;

export const ContentHolder = styled.div`
  width: 100%;
  text-align: center;
  position: relative;
  display: flex;
  align-items: center;
  padding: 80px 30px;
  @media (min-width: 768px) {
    padding: 90px 45px;
  }
`;

export const ImgHolder = styled.div`
  position: relative;
  padding: 25px;
  background-color: #1c1a42;
  background-position: center;
  background-repeat: no-no-repeat;
  background-size: cover;

  @media (min-width: 992px) {
    width: 45%;
  }
  img {
    display: block;
    width: 140px;
    height: auto;
  }
`;

export const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  color: var(--light-gray);
  &:hover {
    i {
      transform: translateX(-5px);
    }
  }
  i {
    color: var(--primary);
    transition: transform 0.3s linear;
  }
`;

export const SubTitle = styled.span`
  margin-bottom: 30px;
  display: block;
  font-size: var(--font-size-lg);
  line-height: calc(var(--font-size-lg) + 5px);
  font-weight: 500;

  @media (min-width: 768px) {
    margin-bottom: 52px;
  }
`;

export const FormHolder = styled.div`
  text-align: left;
  padding: 30px;
  position: relative;
  @media (min-width: 768px) {
    padding: 30px 50px;
  }
  @media (min-width: 992px) {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 55%;
    padding: 30px 100px;
  }
  @media (min-width: 1200px) {
    padding: 30px 150px;
  }
`;

export const FormContent = styled.div`
  width: 100%;
  max-width: 555px;
  margin: 0 auto;
`;
